<script lang="ts">
import type { Colors, Sizes, Orientation, Direction } from 'types';

export interface FieldProps {
  color?: Colors;
  size?: Sizes;
  orientation?: Orientation;
  direction?: Direction;
  label?: string;
  for?: string;
  labelColor?: Colors;
  labelSize?: Sizes;
  required?: boolean;
  description?: string;
  class?: string;
}
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<FieldProps>(), {
  color: 'neutral',
  size: 'md',
  orientation: 'vertical',
  direction: 'ltr'
});

const classes = computed(() => [
  'e-field',
  props.orientation && `e-field-orientation-${props.orientation}`,
  props.direction && `e-field-direction-${props.direction}`
]);

const labelProps = computed(() => {
  const color = props.labelColor ?? props.color;
  const size = props.labelSize ?? props.size;
  return { color: color, size: size, required: props.required };
});
</script>

<template>
  <div :class="classes">
    <slot name="leading">
      <e-label
        v-if="label"
        v-bind="labelProps"
      >
        {{ label }}
      </e-label>
    </slot>
    <slot />
    <slot name="trailing">
      <e-text
        :color="color"
        :size="size"
      >
        {{ description }}
      </e-text>
    </slot>
  </div>
</template>
